/* eslint-disable
    consistent-return,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

class CallQueuer {
  constructor(batch) {
    if (batch == null) {
      batch = 3;
    }
    this.batch = batch;
    this.tasks = [];
    this.id = null;
  }

  process(n) {
    const tasks = this.tasks.splice(0, n);
    if (tasks.length > 0) {
      return Array.from(tasks).map((task) => task.func());
    } else {
      return this.stop();
    }
  }

  resume() {
    if (this.id == null) {
      // eslint-disable-next-line no-restricted-syntax
      return (this.id = setInterval(_.bind(this.process, this), 17, this.batch));
    }
  }

  stop() {
    if (this.id != null) {
      clearInterval(this.id);
      return (this.id = null);
    }
  }

  add(id, f) {
    this.remove(id); // Remove a task if it already exists in the queue for a particular id.
    return this.tasks.push({id, func: f});
  }

  stack(id, f) {
    this.remove(id);
    return this.tasks.unshift({id, func: f});
  }

  remove(id) {
    if (id == null) {
      return;
    }
    const i = this.find(id);
    if (i > -1) {
      return this.tasks.splice(i, 1)[0];
    }
  }

  purge() {
    this.tasks = [];
    return this.stop();
  }

  find(id) {
    // eslint-disable-next-line no-restricted-syntax
    return _.indexOf(
      // eslint-disable-next-line no-restricted-syntax
      _.map(this.tasks, (task) => task.id),
      id
    );
  }

  // Process desired task next.
  restack(id) {
    const task = this.remove(id);
    if (task != null) {
      return this.stack(task.id, task.func);
    }
  }
}

export default CallQueuer;
